import React from "react";

export default function BalanceCard({ name, accountBalance }) {
  return (
    <div className="w-screen md:w-full mb-5 bg-white rounded-lg border border-gray-200 shadow-md">
      <h5 className="rounded-t-lg p-2 mb-2 text-xl font-bold bg-green-800  text-white">
        {name}
      </h5>
      <p className="font-normal text-gray-700 dark:text-gray-400 p-6">
        <div className="flex justify-center  md:justify-start text-xl">
          <div className="font-bold ">{accountBalance}</div>
          <div className="font-bold ml-10">NGN</div>
        </div>
      </p>
      <hr />
    </div>
  );
}
